var map = {
	"./CB-ticket-restau.png": 24062,
	"./abricot.svg": 57782,
	"./arrow.svg": 95719,
	"./bol.svg": 28731,
	"./cheque.jpg": 36296,
	"./corner.svg": 91051,
	"./eurocoin_0.png": 14075,
	"./faim-de-saison-fond-noborder.svg": 34788,
	"./faim-de-saison-fond.svg": 61200,
	"./faimdesaison-legumes-carre-notext-large.png": 27243,
	"./faimdesaison-legumes-carre-notext.png": 54213,
	"./faimdesaison-legumes-large.png": 12699,
	"./fond-tarte-original.jpg": 42930,
	"./fond-tarte-repeat.jpg": 46005,
	"./fond-tarte.jpg": 95232,
	"./lactose.svg": 70481,
	"./logo-couleur-horizontal-no-baseline-400.png": 41938,
	"./logo-couleur-horizontal-no-header-400.png": 54081,
	"./logo-couleur-horizontal-no-header-800.png": 35126,
	"./logo-couleur-horizontal-no-header.svg": 10184,
	"./logo-couleur-horizontal-nobaseline-with-border-400.png": 91629,
	"./logo-couleur-horizontal.png": 36400,
	"./logo.png": 66949,
	"./meat.svg": 35731,
	"./og-image-miam.png": 65881,
	"./pastille-jaune.png": 1088,
	"./poivre-rose.svg": 63385,
	"./sign.png": 60818,
	"./sugar.png": 85074,
	"./tpe-mini-smile.webp": 52998,
	"./tpe-sumup-air.png": 53010,
	"./vegetarien.png": 24963,
	"./wheat.svg": 93813,
	"./xx-faimdesaison-legumes-carre-notext-large.png": 48041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;